import { NgModule } from '@angular/core';

import { TaggerModule } from '../tagger/tagger.module';
import { EmailsInputComponent } from './emails-input.component';

@NgModule({
  exports: [EmailsInputComponent],
  imports: [TaggerModule, EmailsInputComponent],
})
export class EmailsInputModule {}
export { EmailsInputComponent } from './emails-input.component';
